import React from 'react'
import Layout from '../../common/Layout'
import AdministrationLoginContainer from '../../features/AdministrationLogin/AdministrationLoginContainer'
import 'bootstrap/dist/css/bootstrap.min.css';

export default {
  path: '/administration/login',
  async action ({ params }) {
    return {
      title: 'Administration Login',
      component: <Layout containerWell><AdministrationLoginContainer /></Layout>
    }
  }

}
